<template>
    <div>
        {{ test }}
        <button @click="handler">CLICK ME  </button>
    </div>
</template>

<script>
    export default {
        props: ['test'],
        methods: {handler(){
            this.$emit('test123')
        }}
    }
</script>